import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import SuppliersMenu from '../../components/menus/SuppliersMenu';

function SupplierMenuContainer() {
  const { user, supplier } = useSelector((state) => state.role);
  const queryParams = useParams();
  const supplierId = Number(queryParams.supplierId);

  const menuParams = {
    supplierId,
  };

  if (supplierId === supplier?.id) {
    const supplierPermission = user.suppliers.find(({ id }) => id === supplierId);

    menuParams.supplierName = supplier.name;
    menuParams.isAdmin = user.is_super_admin || supplierPermission?.is_admin;
  }

  return <SuppliersMenu {...menuParams} />;
}

export default SupplierMenuContainer;
